(ns manage.poi.locations.columns
  (:require ["@mui/material/Typography$default" :as Typography]
            [cljs-bean.core :refer [->clj]]
            [clojure.string :as str]
            [manage.poi.shared :refer [delete-action-column render-label-chips]]
            [uix.core :refer [$]]))

(def days ["monday" "tuesday" "wednesday" "thursday" "friday" "saturday" "sunday"])

(defn periods->str [periods]
  (when (seq periods)
    (let [[from to] (first periods)]
      (str from "-" to))))

(defn- get-value-dow [row dow]
  (when-let [periods (get-in row [:data dow])]
    (->> periods
         (map (fn [[from to]] (str from "-" to)))
         (str/join " "))))

(defn- dow-column [dow]
  #js {:field (str/lower-case (name dow))
       :headerName (str/capitalize (name dow))
       :flex 1
       :sortable false
       :valueGetter (fn [_ row]
                      (get-value-dow row dow))
       :renderCell (fn [^js params]
                     (let [row (->clj (.-row params))
                           grey? (or (get-in row [:data :always-open])
                                     (get-in row [:data :always-closed]))]
                       ($ Typography {:variant "body2"
                                      :color (if grey? "text.disabled" "text.primary")}
                          (or (.-value params) ""))))})

(defn- simple-column [path & {:keys [header-name sortable value-getter]}]
  #js {:field (str/lower-case (name (last path)))
       :headerName (or header-name (str/capitalize (name (last path))))
       :flex 1
       :sortable (boolean sortable)
       :valueGetter (or value-getter (fn [_ row] (get-in row path)))})

(def sortable-fields
  #{"external-id" "name" "address" "city" "postcode" "created-at"})

(defn location-columns [on-delete]
  #js [(simple-column [:external-id] {:header-name "External ID" :sortable true})
       (simple-column [:data :name] {:sortable true})
       (simple-column [:created-at] {:header-name "Created"})
       (simple-column [:data :lat] {:header-name "Latitude"})
       (simple-column [:data :lon] {:header-name "Longitude"})
       (simple-column [:data :city] {:sortable true})
       (simple-column [:data :address])
       (simple-column [:data :postcode] {:sortable true})

       #js {:field "labels"
            :headerName "Labels"
            :flex 2
            :sortable false
            :valueGetter (fn [_ row] (get-in row [:data :labels]))
            :renderCell render-label-chips}

       #js {:field "schedule"
            :headerName "Schedule"
            :flex 1
            :sortable false
            :valueGetter (fn [_ row] (cond
                                       (get-in row [:data :always-open]) "Open 24/7"
                                       (get-in row [:data :always-closed]) "Closed 24/7"
                                       (get-in row [:data :timezone]) "Weekly"
                                       :else "n/a"))}

       (dow-column :monday)
       (dow-column :tuesday)
       (dow-column :wednesday)
       (dow-column :thursday)
       (dow-column :friday)
       (dow-column :saturday)
       (dow-column :sunday)

       (delete-action-column on-delete
                             (fn [row] {:location-id (:id row)
                                        :location-name (or (get-in row [:data :name])
                                                           (:external-id row))}))])

(defn get-row-id [row]
  (:external-id row))
